module.exports = __webpack_public_path__ + "static/media/1.17.2b7f196f.png";